import { render, staticRenderFns } from "./Rfid.vue?vue&type=template&id=2282e0d2&scoped=true"
import script from "./Rfid.vue?vue&type=script&lang=js"
export * from "./Rfid.vue?vue&type=script&lang=js"
import style0 from "./Rfid.vue?vue&type=style&index=0&id=2282e0d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2282e0d2",
  null
  
)

export default component.exports